<template>
    <div class="col-12 col-sm-12 col-md-12 col-lg-10">
        <div class="right-side-bar-main-sec deposit_section">
            <div class="deposit-withdraw-sec">
                <div class="go-to-back-sec">
                    <a @click="$router.go(-1)">
                        {{ $t('back', 'Back') }}
                    </a>
                    <div class="wallet-minmax">{{ $t('min', 'Min') }}: {{ walletConfig?.deposit_range?.min || 0 }} | {{ $t('max', 'Max') }}: {{ walletConfig?.deposit_range?.max || 0 }}</div>
                </div>
                <div class="dw_bg_cl">
                    <div class="depo-rgt-container amount_container_cl wallet_depo_container_main">
                        <div class="amount_input_cl">
                            <label for="amount1">{{ $t('amount', 'Deposit') }}</label>
                            <div class="amount_input_btn_cl">
                                <input type="number" @input="amount = $helper.sanitizeNumber(+amount, +walletConfig?.deposit_range?.max || 99999999)" :placeholder="$t('enter-amt', 'Enter Deposit amount')" v-model="amount" class="form-control">
                            </div>
                            <div class="amount-select-box"  v-if="walletConfig?.stake_button">
                                <div class="amount-sub-box" v-for="(stake, index) in (userTransactionStakes ? [...userTransactionStakes].slice(0,4) : walletConfig?.stake_button.slice(0,4))" :key="index">
                                    <button type="button" @click="setStakeValue(stake)">+{{ stake }}</button>
                                </div>
                            </div>
                            <div class="submit-btn">
                                <a href="#walleteditstackModal" data-bs-toggle="modal" class="thm-but">
                                    <img loading="lazy" src="@/assets/images/edit-icon.svg" alt="">
                                    {{$t('edit-stake','Edit Stake')}}
                                </a>
                                <button type="button" :disabled="amount < walletConfig?.deposit_range?.min " :class="{'btn-disabled' : amount < walletConfig?.deposit_range?.min }" class="submit_btn_cl" @click="callForDepositMethods()">
                                    {{ $t('submit', 'SUBMIT') }}
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="depo-rgt-container amount_container_cl">
                        <WalletInstructions instructionType="deposit" />
                    </div>
                    <div class="deposit-main-body">
                        <div class="depo-rgt-container deposit_amount_table_cl">
                            <div class="wallet_thm_title">
                                <h2>Transaction History</h2>
                            </div>
                            <WalletHistory :filterType="2"></WalletHistory>
                        </div>
                        <div class="tutorailVideo-sec">
                            <TutorialVideo type = "2"/>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <WalletStakeModal ref="resetStakeCall" v-if="walletConfig" :stakes="walletConfig?.stake_button" />
</template>

<script>

import { defineAsyncComponent } from 'vue';
// import stakesInitialization from '../services/stakesInitialization';
import { setWalletStakeValue} from '../services/wallet.js';
import { mapGetters } from 'vuex';
import WalletInstructions from '../components/WalletInstructions.vue';
import TutorialVideo from '../components/TutorialVideo.vue';
import WalletStakeModal from '../components/WalletStakeModal.vue';
import WalletHistory from '../components/WalletHistory.vue';
export default {
    name: 'WalletDeposit',
    inject: ['walletConfig'],
    // extends: stakesInitialization,
    components: { 
        WalletHistory,
        WalletStakeModal,
        TutorialVideo,
        WalletInstructions,
    },
    data() {
        return {
            amount: null,
        }
    },
    computed: {
        ...mapGetters([
            'globalLoader', 'userTransactionStakes'
        ])
    },
    mounted() {
        if (this.amount !== null) {
            this.handleAmountInput(this.amount);
        }
    },
    methods: {
        setStakeValue(stake) {
            try {
                console.log('stake', stake, this.amount, this.walletConfig);
                const response = setWalletStakeValue(stake, this.amount, this.walletConfig)
                console.log('response', response);
                if(response){
                    this.amount =  response; 
                }
            } catch (error) {
                this.$errorToast(error)
            }
        },
        callForDepositMethods() {
            if (this.amount == null || this.amount < this.walletConfig?.deposit_range?.min || this.amount > this.walletConfig?.deposit_range?.max) {
                this.$errorToast(`The deposit amount must be between ${this.walletConfig?.deposit_range?.min} and ${this.walletConfig?.deposit_range?.max}.`);
            }  else {
                this.goToDepositMethods();
            }
        },
        
        goToDepositMethods() {
            this.$store.dispatch('setDepositAmount', this.amount);
            this.$router.push({ name: 'deposit-payment-method' })
        }
    }
}
</script>
<style scoped>
.btn-disabled{
  pointer-events: none;
  opacity: 0.5;
}
</style>